"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationWrapper = exports.NOTIFICATION_POSITION = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var react_dom_1 = __importDefault(require("react-dom"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DEFAULT_PERSIST_TIME = 5000;
var NOTIFICATION_ROOT_ID = "notification-root";
var NOTIFICATION_WRAPPER_CLASS = "notification-wrapper";
var NOTIFICATION_POSITION;
(function (NOTIFICATION_POSITION) {
    NOTIFICATION_POSITION["Left"] = "left";
    NOTIFICATION_POSITION["Right"] = "right";
})(NOTIFICATION_POSITION || (exports.NOTIFICATION_POSITION = NOTIFICATION_POSITION = {}));
var NotifyUser = (function () {
    function NotifyUser() {
        this.notificationStore = {
            isShowing: false,
            children: undefined,
            type: undefined,
            position: undefined,
        };
        react_dom_1.default.render(react_1.default.createElement(NotificationWrapper, { notificationStore: this.notificationStore, onClose: this.onClose }), document.getElementById(NOTIFICATION_ROOT_ID));
    }
    NotifyUser.prototype.showNotification = function (notificationChildren, notificationType, persistTime, position) {
        if (persistTime === void 0) { persistTime = DEFAULT_PERSIST_TIME; }
        if (position === void 0) { position = NOTIFICATION_POSITION.Right; }
        this.clearTimeout();
        this.notificationStore.isShowing = true;
        this.notificationStore.children = notificationChildren;
        this.notificationStore.type = notificationType;
        this.notificationStore.position = position;
        if (Number.isFinite(persistTime) && persistTime !== 0) {
            this.timeout = window.setTimeout(this.hide, persistTime);
        }
    };
    NotifyUser.prototype.success = function (notificationChildren, persistTime, position) {
        return this.showNotification(notificationChildren, kaleidoscope_1.NotificationType.Success, persistTime, position);
    };
    NotifyUser.prototype.note = function (notificationChildren, persistTime, position) {
        return this.showNotification(notificationChildren, kaleidoscope_1.NotificationType.Info, persistTime, position);
    };
    NotifyUser.prototype.error = function (notificationChildren, persistTime, position) {
        return this.showNotification(notificationChildren, kaleidoscope_1.NotificationType.Error, persistTime, position);
    };
    NotifyUser.prototype.warn = function (notificationChildren, persistTime, position) {
        return this.error(notificationChildren, persistTime, position);
    };
    NotifyUser.prototype.clearNotification = function () {
        this.onClose();
    };
    NotifyUser.prototype.onClose = function () {
        this.hide();
        this.clearTimeout();
    };
    NotifyUser.prototype.hide = function () {
        this.notificationStore.isShowing = false;
    };
    NotifyUser.prototype.clearTimeout = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        }
    };
    var _a, _b, _c, _d, _e, _f;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], NotifyUser.prototype, "notificationStore", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.ReactNode !== "undefined" && react_1.ReactNode) === "function" ? _a : Object, typeof (_b = typeof kaleidoscope_1.NotificationType !== "undefined" && kaleidoscope_1.NotificationType) === "function" ? _b : Object, Object, Object]),
        __metadata("design:returntype", void 0)
    ], NotifyUser.prototype, "showNotification", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof react_1.ReactNode !== "undefined" && react_1.ReactNode) === "function" ? _c : Object, Number, String]),
        __metadata("design:returntype", void 0)
    ], NotifyUser.prototype, "success", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof react_1.ReactNode !== "undefined" && react_1.ReactNode) === "function" ? _d : Object, Number, String]),
        __metadata("design:returntype", void 0)
    ], NotifyUser.prototype, "note", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof react_1.ReactNode !== "undefined" && react_1.ReactNode) === "function" ? _e : Object, Number, String]),
        __metadata("design:returntype", void 0)
    ], NotifyUser.prototype, "error", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof react_1.ReactNode !== "undefined" && react_1.ReactNode) === "function" ? _f : Object, Number, String]),
        __metadata("design:returntype", void 0)
    ], NotifyUser.prototype, "warn", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotifyUser.prototype, "clearNotification", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotifyUser.prototype, "onClose", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotifyUser.prototype, "hide", null);
    return NotifyUser;
}());
exports.default = NotifyUser;
var NotificationWrapper = (function (_super) {
    __extends(NotificationWrapper, _super);
    function NotificationWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationWrapper.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "".concat(NOTIFICATION_WRAPPER_CLASS, " ").concat(NOTIFICATION_WRAPPER_CLASS, "--").concat(this.props.notificationStore.position) },
            react_1.default.createElement(kaleidoscope_1.Notification, { type: this.props.notificationStore.type, onClose: this.props.onClose, isShowing: this.props.notificationStore.isShowing }, this.props.notificationStore.children)));
    };
    NotificationWrapper = __decorate([
        mobx_react_1.observer
    ], NotificationWrapper);
    return NotificationWrapper;
}(react_1.Component));
exports.NotificationWrapper = NotificationWrapper;
